import React, {useState} from "react";
import {Button} from "react-bootstrap";
import {useNavigate} from "react-router-dom";

const DisconnectedSection = () => {
    const session = sessionStorage.getItem("session");

    const navigate = useNavigate();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);

    const handleNavigation = () => {
        let location=window.location.origin+"/";
        if(location === window.location.href){
            navigate("/login/?target=subs")
        }else{
            let target_id=urlSearchParams.get("user");
            let target_cmp=urlSearchParams.get("cmp");
            let ref =urlSearchParams.get("ref");
            navigate(`/login?target=own-page&target_id=${target_id}&target_cmp=${target_cmp}&ref=${ref}`);
        }
    };

    return (
        <section className="container py-5 bg-light">
            <div className="mx-auto">
                {window.location.href === window.location.origin ? (
                    <h1 className="fw-bold">Prêt à commencer ? Contactez-nous ou créez un compte.</h1>
                ) : (
                    <h1 className="fw-bold">Déjà inscrit ? Connectez-vous ou créez votre compte !</h1>
                )}
                <p className="mt-3">
                    Rejoignez Netikash Subscribe et simplifiez la gestion de vos abonnements en quelques clics.
                    Découvrez une nouvelle façon de souscrire, suivre et gérer vos services préférés, le tout depuis un seul et même espace.
                </p>
                <p>
                    <strong>Créez votre compte ou connectez-vous dès maintenant pour :</strong>
                </p>
                <ul>
                    <li>Explorer une large gamme de services disponibles</li>
                    <li>Souscrire en toute simplicité</li>
                    <li>Suivre vos paiements en temps réel</li>
                    <li>Garder le contrôle sur tous vos abonnements</li>
                </ul>
                <p>
                    Avec Netikash Subscribe, votre expérience est centralisée, sécurisée et optimisée.
                </p>
                <p>
                    <strong>Ne manquez rien – inscrivez-vous ou connectez-vous dès aujourd’hui !</strong>
                </p>
                <div className="mt-4 d-flex justify-content-center gap-3">
                    <Button
                        className="btn btn-netikash text-white"
                        onClick={handleNavigation}
                    >
                        {loading ? (
                            <div className="d-flex justify-content-center align-items-center w-px-150">
                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                    <span className="visually-hidden">Chargement...</span>
                                </div>
                            </div>
                        ) : "Se Connecter"}
                    </Button>
                    <Button
                        className="btn btn-outline-netikash"
                        onClick={() => window.open("https://akiba.netikash.com/contact", "_blank")}
                    >
                        Contactez-nous
                    </Button>
                </div>
            </div>

        </section>
    );
};

export default DisconnectedSection;
